import type { FeatureCollection } from 'geojson';
import type { Map as MaplibreMap } from 'maplibre-gl';

const SOURCE_ID = 'spatial-analysis-preview';
const FILL_LAYER_ID = 'spatial-analysis-preview-fill';
const LINE_LAYER_ID = 'spatial-analysis-preview-line';
const POINT_LAYER_ID = 'spatial-analysis-preview-point';

export function removeSpatialAnalysisLayer(map: MaplibreMap): void {
  for (const id of [POINT_LAYER_ID, LINE_LAYER_ID, FILL_LAYER_ID]) {
    if (map.getLayer(id)) map.removeLayer(id);
  }
  if (map.getSource(SOURCE_ID)) map.removeSource(SOURCE_ID);
}

export function showSpatialAnalysisLayer(
  map: MaplibreMap,
  geojson: FeatureCollection,
  bounds: [number, number, number, number] | null,
): void {
  removeSpatialAnalysisLayer(map);
  map.addSource(SOURCE_ID, { type: 'geojson', data: geojson });
  map.addLayer({
    id: FILL_LAYER_ID,
    type: 'fill',
    source: SOURCE_ID,
    filter: ['==', ['geometry-type'], 'Polygon'],
    paint: {
      'fill-color': '#38BDF8',
      'fill-opacity': 0.2,
      'fill-outline-color': '#0EA5E9',
    },
  });
  map.addLayer({
    id: LINE_LAYER_ID,
    type: 'line',
    source: SOURCE_ID,
    filter: ['in', ['geometry-type'], ['literal', ['LineString', 'Polygon']]],
    paint: {
      'line-color': '#38BDF8',
      'line-width': 3,
      'line-opacity': 0.9,
    },
  });
  map.addLayer({
    id: POINT_LAYER_ID,
    type: 'circle',
    source: SOURCE_ID,
    filter: ['==', ['geometry-type'], 'Point'],
    paint: {
      'circle-radius': 6,
      'circle-color': '#FBBF24',
      'circle-stroke-color': '#0F172A',
      'circle-stroke-width': 1.5,
    },
  });

  if (!bounds) return;
  const [west, south, east, north] = bounds;
  if (west === east && south === north) {
    map.easeTo({ center: [west, south], zoom: 11 });
    return;
  }
  map.fitBounds([[west, south], [east, north]], { padding: 50, maxZoom: 12 });
}
